// AccordionContent.tsx
import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { cn } from "@/utils/cn";

export const AccordionContent = (
    props: React.ComponentProps<typeof AccordionPrimitive.Content>
) => {
    const { className, children, ...rest } = props;
    return (
        <AccordionPrimitive.Content
            data-slot="accordion-content"
            className={cn(
                "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
                className
            )}
            {...rest}
        >
            <div className="pt-0 pb-4">{children}</div>
        </AccordionPrimitive.Content>
    );
};
AccordionContent.displayName = "AccordionContent";